import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { PumpSprite, StoreBackShadowSprite, StoreExtSprite, StoreGroundSprite, TiresSprite } from './StoreSprite';

export class StoreBackShadowEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: StoreBackShadowSprite, offset: [-405, -410] }),
    ];
  }
}

export class StoreGroundEntity extends Entity {
  createFacets() {
    return [create(StaticSpriteFacet, { frame: StoreGroundSprite })];
  }
}

export class TiresEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: TiresSprite, offset: [-75, -68] }),
    ];
  }
}

export class PumpEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: PumpSprite, offset: [-105, -255] }),
      create(ColliderFacet, { type: ColliderType.Box, size: [200, 40], offset: [-120, -40] }),
    ];
  }
}

export class StoreEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: StoreExtSprite, offset: [-1040, -1211] }),
      create(ColliderFacet, { type: ColliderType.Box, size: [1250, 420], offset: [-1005, -425] }),
      create(ColliderFacet, { type: ColliderType.Box, size: [100, 420], offset: [942, -425] }),
      create(ColliderFacet, { type: ColliderType.Box, size: [700, 250], offset: [245, -425] }),
    ];
  }
}
